export const SEARCH_TYPE_IDS = {
  CLAIM: 'CLAIM',
  VICTIM_CIN: 'VICTIM_CIN',
  MISSION_REFERENCE: 'MISSION_REFERENCE',
};

export const REQUEST_SEARCH_MISSIONS: string = 'REQUEST_SEARCH_MISSIONS';
export const SET_SEARCH_MISSIONS: string = 'SET_SEARCH_MISSIONS';
export const RESET_SEARCH_MISSIONS_STORE: string =
  'RESET_SEARCH_MISSIONS_STORE';
export const PV_DE_CARENCE_STATUS = 9;
export const FINISHED_STATUS = 5;
